import { Component, OnInit } from '@angular/core';
import { OrderDetailsService } from '@spartacus/order/components';
import { Observable } from 'rxjs';

@Component({
  selector: 'cx-order-details-shipping',
  templateUrl: './custom-order-detail-shipping.component.html',
  standalone: false
})
export class CustomOrderDetailShippingComponent implements OnInit {

  constructor(protected orderDetailsService: OrderDetailsService) { }

  order$: Observable<any>;

  ngOnInit() {
    this.order$ = this.orderDetailsService.getOrderDetails();
  }

}
